module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-fullscreen",
    class: {
      active: _vm.showImg
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.hideFullscreenImg.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "chat-mask"
  }), _vm._v(" "), _c('div', {
    ref: "chatImg",
    staticClass: "chat-image"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-794f5f7a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-794f5f7a"}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/FullscreenImg.vue
// module id = 344
// module chunks = 2